// Generated by Ktorfit
@file:Suppress("warnings")

package one.healthium.meal_plans.`data`

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List

@OptIn(InternalKtorfitApi::class)
public class _MealPlansApiClientImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : MealPlansApiClient {
  override suspend fun getMealPlanInfos(locale: String): List<MealPlanInfoDto> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "${"$locale".encodeURLPath()}/view_models/mealplans.json")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<List<MealPlanInfoDto>>(),)!! 
  }
}

public class _MealPlansApiClientProvider : ClassProvider<MealPlansApiClient> {
  override fun create(_ktorfit: Ktorfit): MealPlansApiClient = _MealPlansApiClientImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createMealPlansApiClient(): MealPlansApiClient = _MealPlansApiClientImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
